import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';
import AddressLoading from '@/_containers/inputs/address/loading';

export default function Loading() {
  return (
    <>
      <CardContainer>
        <SectionHeadingSkeleton />

        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />
        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />

          <InputSkeleton className="col-span-12" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <AddressLoading />
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <AddressLoading />
      </CardContainer>
    </>
  );
}
